<template>
    <div v-if="ticket_id">
        <b-modal
            v-model="showModalLocal"
            :title="'Билет'"
            class="modal-primary"
            size="md"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <template v-if="ticket">
                <form @submit.prevent="handleSubmit">

                    <b-form-group label="вид билета">
                        <select class="form-control" v-model="ticket.type" required>
                            <option value="1">билет на поезд</option>
                            <option value="2">билет на самолет</option>
                            <option value="3">билет на автобус</option>
                            <option value="4">прочий транспорт</option>
                            <option value="5">прочие услуги</option>
                            <option value="6">туристические услуги</option>
                            <option value="7">экскурсионные услуги</option>
                        </select>
                    </b-form-group>

                    <b-form-group label="турист">
                        <select class="form-control" v-model="ticket.guest_id" required>
                            <option v-for="guest in voucherx.guests" :value="guest.id">{{ formatGuest(guest, age=true) }}</option>
                        </select>
                    </b-form-group>

                    <div class="row">
                        <div class="col col-6">
                            <b-form-group label="место отправления">
                                <input class="form-control" v-model="ticket.departure_point">
                            </b-form-group>
                        </div>
                        <div class="col col-6">
                            <b-form-group label="место прибытия">
                                <input class="form-control" v-model="ticket.arrival_point">
                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-6">
                            <b-form-group label="дата отправления" description="отправления или начала оказания услуг">

                                <v-date-picker
                                    v-model='_departure_at'
                                    id="departure_at"
                                    name="departure_at"
                                    data-vv-as="'дата отправления'"
                                    :state="validateState('departure_at')"
                                    :attributes="datepicker_attributes"
                                >
                                    <input
                                        id="departure_at_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        v-bind="inputProps"
                                        v-on="inputEvents"
                                    />
                                </v-date-picker>

                            </b-form-group>
                        </div>

                        <div class="col col-6">
                            <b-form-group label="дата прибытия" description="прибытия или окончания оказания услуг">
                                <v-date-picker
                                    v-model='_arrival_at'
                                    id="arrival_at"
                                    name="arrival_at"
                                    data-vv-as="'дата прибытия'"
                                    :state="validateState('arrival_at')"
                                    :attributes="datepicker_attributes"
                                >
                                    <input
                                        id="arrival_at_input"
                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                        class="form-control form-date-picker"
                                        readonly
                                        v-bind="inputProps"
                                        v-on="inputEvents"
                                    />
                                </v-date-picker>

                            </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col col-6">
                            <b-form-group label="номер рейса" description="рейса, поезда и т.п.">
                                <input class="form-control" v-model="ticket.number">
                            </b-form-group>
                        </div>
                        <div class="col col-6">
                            <b-form-group label="номер заказа" description="номер заказа у продавца билетов">
                                <input class="form-control" v-model="ticket.vendor_number">
                            </b-form-group>
                        </div>
                    </div>

                    <b-form-group label="комментарий" >
                        <textarea class="form-control" v-model="ticket.comment"></textarea>
                    </b-form-group>

                    <div class="row">
                        <div class="col col-6">
                            <b-form-group label="стоимость билета">
                                <input class="form-control" v-model.number="_price">
                            </b-form-group>
                        </div>
                        <div class="col col-6">
                            <b-form-group label="вознаграждение агента">
                                <input class="form-control" v-model.number="_agent_commision">
                            </b-form-group>
                        </div>
                        <!--div class="col col-4">
                            <b-form-group label="вознаграждение агентства">
                                <input class="form-control" v-model.number="_agency_commision">
                            </b-form-group>
                        </div-->
                    </div>


                </form>
                <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                        Закрыть
                    </b-button>
                    <b-button size="sm" variant="outline-success" @click="ok()">
                        Сохранить
                    </b-button>
                </template>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { functions } from '@/functions';
    import { functions_tickets } from '@/functions/tickets.js';
    import { functions_guests } from '@/functions/guests.js';


    export default {
        name: 'TicketEditDialog',
        mixins: [functions, functions_tickets, functions_guests],
        data: function () {
            return {};
        },
        model: {
            prop: "ticket_id",
            event: "hide"
        },
        props: {
            ticket_id: Number,
            voucherx: Object
        },
        watch: {},
        methods: {
            handleCancel: function () {
                //console.log('TicketEditDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                console.log('TicketEditDialog: handleOk');
                let self = this;
                this.saveTicket(function () {
                    self.$emit("hide", false);
                    self.$emit("ok");
                });
            },
            handleSubmit: function () {
                console.log('TicketEditDialog: handleSubmit');
                let self = this;
                this.saveTicket(function () {
                    self.$emit("hide", false);
                    self.$emit("ok");
                });
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return !!this.ticket_id
                },
                set: function (newValue) {
                }
            },

            _departure_at : {
                get: function () {
                    if (!this.is(this.ticket.departure_at)) return null;
                    return new Date(this.ticket.departure_at.slice(0, 10));
                },
                set: function (v) {
                    this.ticket.departure_at = dateToISO(v);
                }
            },

            _arrival_at : {
                get: function () {
                    if (!this.is(this.ticket.arrival_at)) return null;
                    return new Date(this.ticket.arrival_at.slice(0, 10));
                },
                set: function (v) {
                    this.ticket.arrival_at = dateToISO(v);
                }
            },

            _price: {
                set: function(val) {
                    this.ticket.price = Math.round(val*100);
                },
                get: function() {
                    return this.ticket.price/100;
                }
            },

            _agency_commision: {
                set: function(val) {
                    this.ticket.agency_commision = Math.round(val*100);
                },
                get: function() {
                    return this.ticket.agency_commision/100;
                }
            },

            _agent_commision: {
                set: function(val) {
                    this.ticket.agent_commision = Math.round(val*100);
                },
                get: function() {
                    return this.ticket.agent_commision/100;
                }
            },
        },
        created: function () {
            console.log('TicketEditDialog: created');
            this.loadTicket(this.ticket_id);
        },
        mounted: function () {
            console.log('TicketEditDialog: mounted');
        },
        updated: function () {
            console.log('TicketEditDialog: updated');
        },
    }
</script>
